import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import useUpdateApplication from 'features/application/hooks/useUpdateApplication';
import Citizenship from 'features/application/screens/Citizenship/Citizenship';
import useCustomerApplicationOrigination from 'features/signup/hooks/useCustomerApplicationOrigination';
import React from 'react';

const CitizenshipWrapper = () => {
  const {
    application,
    fetching,
    error,
    reExecuteQuery,
    hasApplicationLoaded,
    isReapplication,
  } = useCustomerApplicationOrigination({
    sourceName: SourceName.CITIZENSHIP,
  });

  const {
    updateApplication,
    updateApplicationResult,
    isUpdateApplicationLoading,
    isUpdateApplicationSuccess,
  } = useUpdateApplication({
    applicationId: application?.id,
    sourceName: SourceName.CITIZENSHIP,
  });

  return (
    <Citizenship
      updateApplication={updateApplication}
      fetching={fetching}
      error={error}
      isReapplication={isReapplication}
      hasApplicationLoaded={hasApplicationLoaded}
      nextRoute="/signup/verify-ssn"
      backRoute="/signup/employment"
      isUpdateApplicationLoading={isUpdateApplicationLoading}
      reExecuteQuery={reExecuteQuery}
      updateApplicationResult={updateApplicationResult}
      isUpdateApplicationSuccess={isUpdateApplicationSuccess}
    />
  );
};

export default CitizenshipWrapper;
